import Phaser from 'phaser';
import { CST } from '../../../CST';
import { Score } from '../../../controller/score.js';

export default class Pairs extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.PAIRS);
	}

	preload() {
		// Pairs minigame assets — loaded here so they don't block the initial load
		this.load.image(
			'pairs-bg',
			'assets/Minigames/forgettingme-mini-game/mini-game 3 - Background_1.png',
		);
		this.load.image('match-intro', 'assets/Minigames/forgettingme-mini-game/match-intro.png');
		this.load.image('match-outro', 'assets/Minigames/forgettingme-mini-game/match-outro.png');
		this.load.atlas(
			'icons-1',
			'assets/Minigames/forgettingme-mini-game/icons.png',
			'assets/Minigames/forgettingme-mini-game/icons.json',
		);
		this.load.audio('clock-sound', 'assets/Sounds/clock-sound.mp3');
		this.load.audio('correct-sound', 'assets/Sounds/correct-sound.mp3');
		this.load.audio('wrong-sound', 'assets/Sounds/wrong-sound.mp3');
		this.load.audio('congratulations-sound', 'assets/Sounds/congratulations.mp3');
		this.load.audio('pop2-sound', 'assets/Sounds/pop2.mp3');
		// Variable declarations
		this.minigameIntro;
		this.pairsIntro;
		this.pairsOutro;
		this.playButton;
		this.emojis;
		this.circle1;
		this.circle2;
		this.child1;
		this.child2;
		this.selectedEmoji = null;
		this.matched = false;
		this.timer;
		this.timerText;
		this.pairsBackground;
		this.pairsScore = 0;
		this.pairsFound = 0;
		this.endGamePopUp;
		this.endGameButton;
		this.pairsBlackBackground;
	}

	create() {
		this.clickSound = this.sound.add('click-sound', {
			volume: 0.5,
		});
		this.clock = this.sound.add('clock-sound');
		this.pop2 = this.sound.add('pop2-sound', {
			volume: 0.5,
		});
		this.congratulations = this.sound.add('congratulations-sound');
		this.wrong = this.sound.add('wrong-sound');
		this.score = new Score(this);
		this.pairsBackground = this.add.image(750, 400, 'pairs-bg');
		this.pairsBackground.setScale(0.9);
		//  Create a 4x4 grid aligned group to hold our sprites
		this.emojis = this.add.group({
			key: 'icons-1',
			frameQuantity: 1,
			repeat: 15,
			gridAlign: {
				width: 4,
				height: 4,
				cellWidth: 180,
				cellHeight: 180,
				x: 460,
				y: 140,
			},
		});
		const fontStyle = {
			fontFamily: 'Calibri',
			fontSize: 48,
			color: '#ffffff',
			fontStyle: 'bold',
			padding: 16,
			shadow: {
				color: '#000000',
				fill: true,
				offsetX: 2,
				offsetY: 2,
				blur: 4,
			},
		};
		this.timerText = this.add.text(0, 0, '30:00', fontStyle);
		this.pairsFoundText = this.add.text(1200, 0, 'Pairs found: 0', fontStyle);
		let children = this.emojis.getChildren();
		children.forEach(child => {
			child.setInteractive();
		});
		this.pairsBlackBackground = this.add.image(750, 400, 'black-bg');
		this.pairsBlackBackground.setAlpha(0.55);
		this.pairsBlackBackground.setScale(8);
		this.pairsIntro = this.add.image(750, 400, 'match-intro');
		this.playButton = this.add.image(750, 750, 'play-btn').setScale(0.5);
		this.playButton
			.setInteractive({
				useHandCursor: true,
			})
			.on(
				'pointerdown',
				function () {
					this.clickSound.play();
					destroySprite(this.pairsIntro);
					destroySprite(this.pairsBlackBackground);
					destroySprite(this.playButton);
					this.circle1 = this.add.circle(0, 0, 90).setStrokeStyle(3, 0xf8960e);
					this.circle2 = this.add.circle(0, 0, 90).setStrokeStyle(3, 0x00ff00);
					this.circle1.setVisible(false);
					this.circle2.setVisible(false);
					this.input.on('gameobjectdown', this.selectEmoji, this);
					this.input.once('pointerup', this.start, this);
					this.arrangeGrid();
				},
				this,
			);
	}

	start() {
		this.clock.play();
		this.matched = false;
		this.timer = this.time.addEvent({
			delay: 30000,
			callback: this.gameOver,
			callbackScope: this,
		});
	}

	selectEmoji(pointer, emoji) {
		this.pop2.play();
		if (this.matched) {
			return;
		}
		//  Is this the first or second selection?
		if (!this.selectedEmoji) {
			//  Our first emoji
			this.circle1.setPosition(emoji.x, emoji.y - 2);
			this.circle1.setVisible(true);
			this.selectedEmoji = emoji;
		} else if (emoji !== this.selectedEmoji) {
			//  Our second emoji
			//  Is it a match?
			if (emoji.frame.name === this.selectedEmoji.frame.name) {
				//this.correct.play();
				this.circle1.setStrokeStyle(3, 0x00ff00);
				this.circle2.setPosition(emoji.x, emoji.y - 2);
				this.circle2.setVisible(true);
				this.tweens.add({
					targets: [this.child1, this.child2],
					scale: 1.4,
					angle: '-=30',
					yoyo: true,
					ease: 'sine.inout',
					duration: 200,
					completeDelay: 200,
					onComplete: () => this.newRound(),
				});
			} else {
				this.wrong.play();
				this.circle1.setPosition(emoji.x, emoji.y);
				this.circle1.setVisible(true);
				this.selectedEmoji = emoji;
			}
		}
	}

	newRound() {
		this.matched = false;
		this.score.addPoints();
		this.pairsScore++;
		this.pairsFound++;
		this.pairsFoundText.setText('Pairs found: ' + this.pairsFound);
		this.circle1.setStrokeStyle(3, 0xf8960e);
		this.circle1.setVisible(false);
		this.circle2.setVisible(false);
		//  Stagger tween them all out
		this.tweens.add({
			targets: this.emojis.getChildren(),
			scale: 0,
			ease: 'power2',
			duration: 600,
			delay: this.tweens.stagger(100, {
				grid: [4, 4],
				from: 'center',
			}),
			onComplete: () => this.arrangeGrid(),
		});
	}

	arrangeGrid() {
		//  We need to make sure there is only one pair in the grid
		//  Let's create an array with all possible frames in it:
		let frames = Phaser.Utils.Array.NumberArray(1, 16);
		let selected = Phaser.Utils.Array.NumberArray(0, 15);
		let children = this.emojis.getChildren();
		//  Now we pick 16 random values, removing each one from the array so we can't pick it again
		//  and set those into the sprites
		for (let i = 0; i < 16; i++) {
			let frame = Phaser.Utils.Array.RemoveRandomElement(frames);
			children[i].setFrame('smile' + frame);
		}
		//  Finally, pick two random children and make them a pair:
		let index1 = Phaser.Utils.Array.RemoveRandomElement(selected);
		let index2 = Phaser.Utils.Array.RemoveRandomElement(selected);
		this.child1 = children[index1];
		this.child2 = children[index2];
		//  Set the frame to match
		this.child2.setFrame(this.child1.frame.name);
		//  Clear the currently selected emojis (if any)
		this.selectedEmoji = null;
		//  Stagger tween them all in
		this.tweens.add({
			targets: children,
			scale: {
				start: 0,
				from: 0,
				to: 1,
			},
			ease: 'bounce.out',
			duration: 600,
			delay: this.tweens.stagger(100, {
				grid: [4, 4],
				from: 'center',
			}),
		});
	}

	update() {
		if (this.timer) {
			if (this.timer.getProgress() === 1) {
				this.clock.stop();
				this.timerText.setText('00:00');
			} else {
				const remaining = (30 - this.timer.getElapsedSeconds()).toPrecision(4);
				const pos = remaining.indexOf('.');
				let seconds = remaining.substring(0, pos);
				let ms = remaining.substr(pos + 1, 2);
				seconds = Phaser.Utils.String.Pad(seconds, 2, '0', 1);
				this.timerText.setText(seconds + ':' + ms);
			}
		}
	}

	gameOver(music) {
		//  Show them where the match actually was
		this.circle1
			.setStrokeStyle(4, 0xfc29a6)
			.setPosition(this.child1.x, this.child1.y)
			.setVisible(true);
		this.circle2
			.setStrokeStyle(4, 0xfc29a6)
			.setPosition(this.child2.x, this.child2.y)
			.setVisible(true);

		this.input.off('gameobjectdown', this.selectEmoji, this);
		this.congratulations.play();
		this.tweens.add({
			targets: [this.circle1, this.circle2],
			alpha: 0,
			yoyo: true,
			repeat: 2,
			duration: 250,
			ease: 'sine.inout',
			onComplete: () => {
				setTimeout(() => {
					this.pairsBlackBackground = this.add.image(750, 400, 'black-bg');
					this.pairsBlackBackground.setAlpha(0.55);
					this.pairsBlackBackground.setScale(8);
					//click.play();
					this.pairsOutro = this.add.image(750, 400, 'match-outro');
					this.endGameButton = this.add.image(750, 700, 'next-btn').setScale(0.5);
					this.endGameButton
						.setInteractive({
							useHandCursor: true,
						})
						.on(
							'pointerdown',
							function () {
								destroySprite(this.pairsOutro);
								destroySprite(this.endGameButton);
								this.scene.resume(CST.SCENES.STORY_SELECT, {
									story: 1,
								});
								this.scene.stop();
							},
							this,
						);
				}, 1500);
			},
		});
	}
}

function destroySprite(sprite) {
	sprite.destroy();
}
